import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-500/15 text-secondary-400 border border-secondary-500/20 mb-3">
              <i className="ri-information-line mr-1"></i>品牌介绍
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              {aboutContent.title}
            </h2>
            <p className="text-foreground-500 leading-relaxed text-sm md:text-base">
              {aboutContent.description}
            </p>
          </div>

          <div className="space-y-4">
            {aboutContent.highlights.map((item) => (
              <div
                key={item.label}
                className="flex gap-4 p-4 rounded-xl bg-background-100 border border-background-200/50"
              >
                <span className="flex-shrink-0 w-11 h-11 rounded-lg bg-primary-500/10 flex items-center justify-center">
                  <i className={`${item.icon} text-lg text-primary-400`}></i>
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-800">{item.label}</h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}